export enum PlataformaTypes {
  'LOAD_REQUEST' = '@plataforma/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@plataforma/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@plataforma/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@plataforma/CLEAN_MOVIENTRADA',
}
export interface IPlataforma {
  codPlataforma: number;
  descricao: string;
}

export interface PlataformaState {
  readonly data: IPlataforma[];
  readonly loading: boolean;
  readonly error: boolean;
}
